module.exports = __webpack_public_path__ + "h5/img/conversion.ba82ab6e.png";